import {
  HttpContextToken,
  HttpErrorResponse,
  HttpInterceptorFn,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { catchError, throwError } from 'rxjs';

export const SKIP_GLOBAL_ERROR_NOTIFICATION = new HttpContextToken<boolean>(() => false);

interface ErrorNotification {
  message: string;
  title: string;
}

export const httpErrorInterceptor: HttpInterceptorFn = (request, next) => {
  const toastr = inject(ToastrService);

  return next(request).pipe(
    catchError((error: unknown) => {
      if (!request.context.get(SKIP_GLOBAL_ERROR_NOTIFICATION)) {
        const notification = getErrorNotification(error);
        if (notification) {
          toastr.error(notification.message, notification.title);
        }
      }

      return throwError(() => error);
    }),
  );
};

export function getErrorNotification(error: unknown): ErrorNotification | null {
  if (!(error instanceof HttpErrorResponse)) {
    return null;
  }

  if (error.status === 0) {
    return {
      title: 'Nätverksfel',
      message: 'Kunde inte kontakta servern. Kontrollera anslutningen och försök igen.',
    };
  }
  if (error.status === 401) {
    return {
      title: 'Sessionen har gått ut',
      message: 'Logga in igen för att fortsätta.',
    };
  }
  if (error.status === 403) {
    return {
      title: 'Åtkomst nekad',
      message: 'Du saknar behörighet för den här åtgärden.',
    };
  }
  if (error.status >= 500) {
    return {
      title: 'Serverfel',
      message: 'Ett oväntat serverfel inträffade. Försök igen senare.',
    };
  }

  return null;
}
